/* eslint-disable react-hooks/exhaustive-deps */
import axios from 'axios';
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { saveAll } from '../../store/items';
import {
  getAvatarBackgroundStyle,
  getItemPicAsset,
  canAccessItem,
} from '../../utils/item';
import { Link } from 'react-router-dom';
import { isGlobalAdmin, linkWithMJparam } from '../../utils/roles';
import { fetchImage } from '../../utils/img';
import { renderIconBySlug } from '../../content/icons';

const isValidObjectId = id => typeof id === 'string' && /^[a-f0-9]{24}$/i.test(id);

export const CardItemHome = props => {
  const { item, isUniverse } = props;

  const campaign = useSelector(state => state.items[item?.campaign]);
  const world = useSelector(state => state.items[item?.world]);
  const universe = useSelector(state => state.items[item?.universe]);

  const dispatch = useDispatch();

  const [avatar, setAvatar] = useState(null);
  const [banner, setBanner] = useState(null);
  const [avatarIconSlug, setAvatarIconSlug] = useState(null);
  const [avatarBgColor, setAvatarBgColor] = useState(null);
  const missingParentIdsRef = useRef(new Set());

  const getItem = async id => {
    if (!isValidObjectId(id) || missingParentIdsRef.current.has(id)) {
      return;
    }
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_URL}/items/${id}`);
      if (res.data?._id) {
        dispatch(saveAll({ item: res.data }));
      }
    } catch (error) {
      if (error?.response?.status === 404) {
        missingParentIdsRef.current.add(id);
      }
    }
  };

  useEffect(() => {
    if (!campaign && item?.campaign) getItem(item.campaign);
    if (!world && item?.world) getItem(item.world);
    if (!universe && item?.universe) getItem(item.universe);

    const avatarAsset = getItemPicAsset(item, 0);
    const bannerAsset = getItemPicAsset(item, 1);

    if (avatarAsset.url) {
      fetchImage(avatarAsset.url, setAvatar);
    } else {
      setAvatar(null);
    }
    if (bannerAsset.url) {
      fetchImage(bannerAsset.url, setBanner);
    } else {
      setBanner(null);
    }

    setAvatarIconSlug(avatarAsset.iconSlug);
    setAvatarBgColor(avatarAsset.bgColor ?? null);
  }, [item, campaign, world, universe]);

  const accessBlocksPublic =
    (item?.type === 'campaign' && item?.access?.visibility === 'private') ||
    (item?.type === 'universe' && item?.access?.visibility === 'private') ||
    campaign?.access?.visibility === 'private' ||
    universe?.access?.visibility === 'private';
  const legacyPublic =
    !accessBlocksPublic &&
    !item?.password &&
    (!item?.campaign || (campaign && !campaign?.password)) &&
    (!item?.world || (world && !world?.password)) &&
    (!item?.universe || (universe && !universe?.password));
  const canShow =
    isGlobalAdmin() ||
    isUniverse ||
    canAccessItem(item, campaign, world, universe) ||
    legacyPublic;

  if (canShow)
    return (
      <div className='w-full'>
        <Link
          to={`../../item/${item?._id}${
            isGlobalAdmin() ? '?' + linkWithMJparam() : ''
          }`}
          className='cursor-pointer'
        >
          <div
            className='bg-main shadow rounded-lg p-1 relative'
            style={{
              ...(banner
                ? {
                    backgroundImage: `url(${banner})`,
                    backgroundPosition: 'center',
                    backgroundSize: 'cover',
                  }
                : {}),
            }}
          >
            {banner && (
              <div className='absolute w-full h-full bg-gradient-to-t from-main via-main to-transparent top-0 left-0 rounded'></div>
            )}

            <div className='flex justify-center items-center p-1 relative z-10'>
              {(avatarIconSlug || avatar) && (
                <div
                  className='rounded-full shadow flex items-center justify-center'
                  style={{
                    ...(avatarBgColor
                      ? getAvatarBackgroundStyle(avatarBgColor)
                      : { backgroundColor: 'rgba(var(--main), 0.5)' }),
                  }}
                >
                  {avatarIconSlug ? (
                    renderIconBySlug(avatarIconSlug, {
                      size: 64,
                      color: 'var(--contrast)',
                    })
                  ) : (
                    <div
                      className='w-20 h-20 rounded-full'
                      style={{
                        background: `url(${avatar}) center center / cover`,
                      }}
                    ></div>
                  )}
                </div>
              )}
              <div className='text-center bg-transparent w-full font-condensed text-2xl p-05'>
                {item?.label}
              </div>
            </div>
          </div>
        </Link>
      </div>
    );
  else {
    return <></>;
  }
};
